import { useMemo } from 'react';
import { InsuranceState } from '../../../../../Generated/Raven-Demeter';
import Dropdown from '../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import { GeneralRiskCalculationInputs } from '../DairyRevenueProtection/DairyRevenueProtectionDefinitions';

interface IGeneralRiskInsuranceStateDropdownProps {
    calculationInputs: GeneralRiskCalculationInputs;
    setCalculatorInputs: (value: GeneralRiskCalculationInputs) => void;
}

const GeneralRiskInsuranceStateDropdown: React.FC<IGeneralRiskInsuranceStateDropdownProps> = (props: IGeneralRiskInsuranceStateDropdownProps) => {
    const [translations] = useLanguage();

    const stateOptions = useMemo(
        () => [
            {
                value: InsuranceState.Alabama,
                label: translations.insuranceState[InsuranceState.Alabama],
            },
            {
                value: InsuranceState.Alaska,
                label: translations.insuranceState[InsuranceState.Alaska],
            },
            {
                value: InsuranceState.Arizona,
                label: translations.insuranceState[InsuranceState.Arizona],
            },
            {
                value: InsuranceState.Arkansas,
                label: translations.insuranceState[InsuranceState.Arkansas],
            },
            {
                value: InsuranceState.California,
                label: translations.insuranceState[InsuranceState.California],
            },
            {
                value: InsuranceState.Colorado,
                label: translations.insuranceState[InsuranceState.Colorado],
            },
            {
                value: InsuranceState.Connecticut,
                label: translations.insuranceState[InsuranceState.Connecticut],
            },
            {
                value: InsuranceState.Delaware,
                label: translations.insuranceState[InsuranceState.Delaware],
            },
            {
                value: InsuranceState.Florida,
                label: translations.insuranceState[InsuranceState.Florida],
            },
            {
                value: InsuranceState.Georgia,
                label: translations.insuranceState[InsuranceState.Georgia],
            },
            {
                value: InsuranceState.Hawaii,
                label: translations.insuranceState[InsuranceState.Hawaii],
            },
            {
                value: InsuranceState.Idaho,
                label: translations.insuranceState[InsuranceState.Idaho],
            },
            {
                value: InsuranceState.Illinois,
                label: translations.insuranceState[InsuranceState.Illinois],
            },
            {
                value: InsuranceState.Indiana,
                label: translations.insuranceState[InsuranceState.Indiana],
            },
            {
                value: InsuranceState.Iowa,
                label: translations.insuranceState[InsuranceState.Iowa],
            },
            {
                value: InsuranceState.Kansas,
                label: translations.insuranceState[InsuranceState.Kansas],
            },
            {
                value: InsuranceState.Kentucky,
                label: translations.insuranceState[InsuranceState.Kentucky],
            },
            {
                value: InsuranceState.Louisiana,
                label: translations.insuranceState[InsuranceState.Louisiana],
            },
            {
                value: InsuranceState.Maine,
                label: translations.insuranceState[InsuranceState.Maine],
            },
            {
                value: InsuranceState.Maryland,
                label: translations.insuranceState[InsuranceState.Maryland],
            },
            {
                value: InsuranceState.Massachusetts,
                label: translations.insuranceState[InsuranceState.Massachusetts],
            },
            {
                value: InsuranceState.Michigan,
                label: translations.insuranceState[InsuranceState.Michigan],
            },
            {
                value: InsuranceState.Minnesota,
                label: translations.insuranceState[InsuranceState.Minnesota],
            },
            {
                value: InsuranceState.Mississippi,
                label: translations.insuranceState[InsuranceState.Mississippi],
            },
            {
                value: InsuranceState.Missouri,
                label: translations.insuranceState[InsuranceState.Missouri],
            },
            {
                value: InsuranceState.Montana,
                label: translations.insuranceState[InsuranceState.Montana],
            },
            {
                value: InsuranceState.Nebraska,
                label: translations.insuranceState[InsuranceState.Nebraska],
            },
            {
                value: InsuranceState.Nevada,
                label: translations.insuranceState[InsuranceState.Nevada],
            },
            {
                value: InsuranceState.NewHampshire,
                label: translations.insuranceState[InsuranceState.NewHampshire],
            },
            {
                value: InsuranceState.NewJersey,
                label: translations.insuranceState[InsuranceState.NewJersey],
            },
            {
                value: InsuranceState.NewMexico,
                label: translations.insuranceState[InsuranceState.NewMexico],
            },
            {
                value: InsuranceState.NewYork,
                label: translations.insuranceState[InsuranceState.NewYork],
            },
            {
                value: InsuranceState.NorthCarolina,
                label: translations.insuranceState[InsuranceState.NorthCarolina],
            },
            {
                value: InsuranceState.NorthDakota,
                label: translations.insuranceState[InsuranceState.NorthDakota],
            },
            {
                value: InsuranceState.Ohio,
                label: translations.insuranceState[InsuranceState.Ohio],
            },
            {
                value: InsuranceState.Oklahoma,
                label: translations.insuranceState[InsuranceState.Oklahoma],
            },
            {
                value: InsuranceState.Oregon,
                label: translations.insuranceState[InsuranceState.Oregon],
            },
            {
                value: InsuranceState.Pennsylvania,
                label: translations.insuranceState[InsuranceState.Pennsylvania],
            },
            {
                value: InsuranceState.RhodeIsland,
                label: translations.insuranceState[InsuranceState.RhodeIsland],
            },
            {
                value: InsuranceState.SouthCarolina,
                label: translations.insuranceState[InsuranceState.SouthCarolina],
            },
            {
                value: InsuranceState.SouthDakota,
                label: translations.insuranceState[InsuranceState.SouthDakota],
            },
            {
                value: InsuranceState.Tennessee,
                label: translations.insuranceState[InsuranceState.Tennessee],
            },
            {
                value: InsuranceState.Texas,
                label: translations.insuranceState[InsuranceState.Texas],
            },
            {
                value: InsuranceState.Utah,
                label: translations.insuranceState[InsuranceState.Utah],
            },
            {
                value: InsuranceState.Vermont,
                label: translations.insuranceState[InsuranceState.Vermont],
            },
            {
                value: InsuranceState.Virginia,
                label: translations.insuranceState[InsuranceState.Virginia],
            },
            {
                value: InsuranceState.Washington,
                label: translations.insuranceState[InsuranceState.Washington],
            },
            {
                value: InsuranceState.WestVirginia,
                label: translations.insuranceState[InsuranceState.WestVirginia],
            },
            {
                value: InsuranceState.Wisconsin,
                label: translations.insuranceState[InsuranceState.Wisconsin],
            },
            {
                value: InsuranceState.Wyoming,
                label: translations.insuranceState[InsuranceState.Wyoming],
            },
        ],
        [translations],
    );

    return (
        <Dropdown
            value={props.calculationInputs.insuranceState}
            options={stateOptions}
            handleOptionChange={(value) => props.setCalculatorInputs({ ...props.calculationInputs, insuranceState: value })}
            label={translations.risk.margin.fields.state}
            track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'InsuranceStateChanged' }}
        />
    );
};

export default GeneralRiskInsuranceStateDropdown;
